import { swapKeysAndValues as O } from "./object.mjs";
const R = " ", C = {
  CNY: "¥",
  EUR: "€",
  TRY: "₺",
  GBP: "£",
  USD: "$",
  AUD: "$",
  CHF: "CHF",
  PLN: "zł",
  SEK: "kr",
  DKK: "kr.",
  CZK: "Kč",
  NOK: "kr",
  BGN: "лв.",
  RON: "RON",
  INR: "₹",
  // We decided to have code instead of RTL symbols to all currencies below.
  AED: "AED",
  JOD: "JOD",
  OMR: "OMR",
  SAR: "SAR",
  QAR: "QAR",
  BHD: "BHD"
}, D = O(C), N = {
  CNY: ",",
  EUR: ".",
  TRY: ".",
  GBP: ",",
  USD: ",",
  AUD: ",",
  CHF: "’",
  PLN: R,
  SEK: R,
  DKK: ".",
  CZK: R,
  NOK: R,
  BGN: R,
  RON: ".",
  INR: ".",
  AED: ",",
  JOD: ",",
  OMR: ",",
  SAR: ",",
  QAR: ",",
  BHD: ","
}, E = {
  CNY: ".",
  EUR: ",",
  TRY: ",",
  GBP: ".",
  USD: ".",
  AUD: ".",
  CHF: ".",
  PLN: ",",
  SEK: ",",
  DKK: ",",
  CZK: ",",
  NOK: ",",
  BGN: ",",
  RON: ",",
  INR: ",",
  AED: ".",
  JOD: ".",
  OMR: ".",
  SAR: ".",
  QAR: ".",
  BHD: "."
}, A = {
  CNY: "",
  EUR: R,
  TRY: "",
  GBP: "",
  USD: "",
  AUD: "",
  CHF: R,
  PLN: R,
  SEK: R,
  DKK: R,
  CZK: R,
  NOK: R,
  BGN: R,
  RON: R,
  INR: R,
  AED: R,
  JOD: R,
  OMR: R,
  SAR: R,
  QAR: R,
  BHD: R
}, r = {
  CNY: "before",
  EUR: "after",
  TRY: "before",
  GBP: "before",
  USD: "before",
  AUD: "before",
  CHF: "before",
  PLN: "after",
  SEK: "after",
  DKK: "after",
  CZK: "after",
  NOK: "after",
  BGN: "after",
  RON: "after",
  INR: "before",
  AED: "before",
  JOD: "before",
  OMR: "before",
  SAR: "before",
  QAR: "before",
  BHD: "before"
}, K = {
  AED: !0,
  JOD: !0,
  OMR: !0,
  SAR: !0,
  QAR: !0,
  BHD: !0
};
export {
  E as CURRENCY_CODE_TO_CENTS_SEPARATOR,
  r as CURRENCY_CODE_TO_CURRENCY_SYMBOL_PLACE,
  A as CURRENCY_CODE_TO_CURRENCY_SYMBOL_SEPARATOR,
  K as CURRENCY_CODE_TO_RTL,
  N as CURRENCY_CODE_TO_SEPARATOR,
  C as CURRENCY_CODE_TO_SYMBOL,
  D as CURRENCY_SYMBOL_TO_CODE
};
//# sourceMappingURL=moneyUtils.consts.mjs.map
